import { useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { useMarket } from "src/feature/market-place/hook";
import * as Yup from "yup";

const validSchema = Yup.object({
  firstName: Yup.string(),
  lastName: Yup.string(),
  addressLine: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  zipCode: Yup.string(),
  country: Yup.string(),
  cardName: Yup.string(),
  cardNumber: Yup.string(),
  cardExpiryMonth: Yup.string(),
  cardExpiryYear: Yup.string(),
  cardCvv: Yup.string(),
});

type ValidSchema = Yup.InferType<typeof validSchema>;

export default function MarketPlace() {
  const { values } = useFormikContext<ValidSchema>();
  const intl = useIntl();
  const { basket } = useMarket()

  const discount = 0;

  return (
    <div className="pb-5" data-wizard-type="step-content">
      <h4 className="mb-10 font-weight-bold text-dark">
        {intl.formatMessage({ id: 'CHECKOUT.PURCHASE.CONTENT' })}
      </h4>
      <h6 className="font-weight-bolder mb-3">
        {intl.formatMessage({ id: 'CHECKOUT.PURCHASE.DELIVERY_ADDRESS' })}
      </h6>
      <div className="text-dark-50 line-height-lg">
        <div>{values?.addressLine}</div>
        <div>{values.zipCode}, {values.state}, {values.country}</div>
      </div>
      <div className="separator separator-dashed my-5"></div>

      <h6 className="font-weight-bolder mb-3">
        {intl.formatMessage({ id: 'CHECKOUT.PURCHASE.ORDER_DETAIL' })}
      </h6>
      <div className="text-dark-50 line-height-lg">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th className="pl-0 font-weight-bold text-muted  text-uppercase">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.ORDERED' })}</th>
                <th className="text-right font-weight-bold text-muted text-uppercase">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.QUANTITY' })}</th>
                <th colSpan={2} className="text-right font-weight-bold text-muted text-uppercase">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.PRICE' })}</th>
                {/* <th className="text-right pr-0 font-weight-bold text-muted text-uppercase">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.AMOUNT' })}</th> */}
              </tr>
            </thead>
            <tbody>
              {basket?.basketItemList.map((item, index) => (
                <tr className="font-weight-boldest">
                  <td className="border-0 pl-0 pt-7 d-flex align-items-center">
                    <div className="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                      {/* <div className="symbol-label" style={{ backgroundImage: `url(${item.product.image})` }}></div> */}
                      <img src={item.product.image} alt="" style={{ maxHeight: 100 }} />
                    </div>
                    <span className="ml-2">{item.product.name}</span>
                  </td>
                  <td className="text-right pt-7 align-middle">1</td>
                  <td colSpan={2} className="text-right pt-7 align-middle">${item.product.price}</td>
                  {/* <td className="text-primary pr-0 pt-7 text-right align-middle">${item.price * (item?.quantity || 1)}</td> */}
                </tr>
              ))}
              <tr>
                <td colSpan={2}></td>
                <td className="font-weight-bolder text-right">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.SUBTOTAL' })}</td>
                <td className="font-weight-bolder text-right pr-0">${basket?.totalPrice}</td>
              </tr>
              <tr>
                <td colSpan={2} className="border-0 pt-0"></td>
                <td className="border-0 pt-0 font-weight-bolder text-right">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.DISCOUNT' })}</td>
                <td className="border-0 pt-0 font-weight-bolder text-right pr-0">${discount}</td>
              </tr>
              <tr>
                <td colSpan={2} className="border-0 pt-0"></td>
                <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-right">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.TOTAL' })}</td>
                <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-success text-right pr-0">
                  {/* ${items.reduce((acc, item) => acc + (item.price * (item?.quantity || 1)), 0) + discount} */}
                  ${(basket?.totalPrice || 0) + discount}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* <div className="separator separator-dashed my-5"></div> */}

      {/* <h6 className="font-weight-bolder mb-3">
        {intl.formatMessage({ id: 'CHECKOUT.PURCHASE.DELIVERY_SERVICE_TYPE' })}
      </h6>
      <div className="text-dark-50 line-height-lg">
        <div>{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.DELIVERY_SERVICE_CONTENT_ONE' })}</div>
        <div>{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.DELIVERY_SERVICE_CONTENT_TWO' })}</div>
      </div> */}
    </div>
  )
}
